module.exports = __webpack_public_path__ + "static/media/2030089000.dfc1c4b7.jpg";